import script from "./SelectAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectAccountPage.vue?vue&type=style&index=0&id=4bee30d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bee30d0"]])

export default __exports__